export const EMAIL_REGEXP =
  /^[A-Z0-9_\.%\+\-\']+@(?:[A-Z0-9\-]+\.)+(?:[A-Z]{2,11})$/i;

angular.module("ticketco/common").directive("tcEmail", function tcZipCode() {
  return {
    require: "ngModel",
    link: function (scope, elem, attrs, ngModelCtrl) {
      ngModelCtrl.$validators.email = function (modelValue, viewValue) {
        var email = modelValue || viewValue;
        if (email == null || email == "") {
          return true;
        }
        return EMAIL_REGEXP.test(email);
      };
    },
  };
});
